<template>
    <div class="meterContainer">
        <div class="apple">
        </div>
        <div
            v-for="(apple, index) in getAppleCount"
            :key="index"
            class="applePoint"
            v-bind:style="{'bottom':applePosY(index)+'%','z-index':appleIndex(index), 'transform': 'rotate('+appleRotate(index)+'deg)'}"
        >
            <transition name="fade" appear>
                <img
                    v-if="checkForExplosion(index)"
                    class="appleImageExplosion"
                    src="../assets/images/applesplosion.gif"
                >
                <img
                    class="pointImage"
                    v-else-if="showGoldenApple"
                    :key="index+'gold'"
                    src="../assets/images/apple-gold.svg"
                >
                <img
                    class="pointImage"
                    v-else-if="!showGoldenApple"
                    :key="index+'red'"
                    src="../assets/images/apple.svg"
                >
            </transition>
        </div>
        <div class="tube">
            <div class="highlight"></div>
            <div class="threshold" v-bind:style="{'bottom':thresholdPosY+'%'}">
                <img v-if="thresholdReached" src="../assets/images/threshold-on.svg" alt>
                <img v-else src="../assets/images/threshold-off.svg" alt>
            </div>
            <div class="top"></div>
            <div class="middle"></div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";
import Score from "./score.vue";
export default {
    name: "scoreMeter",
    data() {
        return {
            appleRotations: [],
            doExplosion: false,
            audioSwoosh: new Audio()
        };
    },
    components: {
        appScore: Score
    },
    props: {
        showAppleAnimation: {
            type:Boolean,
            default: false
        },
        maxScore: {
            type: Number,
            default: 0
        },
        score: {
            type: Number,
            default: 0
        },
        thresholdCounter: {
            type: Number,
            default: 0
        },
        threshold: {
            type: Number,
            default: 0
        },
        nrQuestions: {
            type: Number,
            default: 0
        },
        questionsLeft: {
            type: Number,
            default: 0
        },
        appleScore: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showGoldenApple() {
            if (this.showAppleAnimation && this.thresholdReached) {
                return true;
            } else {
                return false;
            }
        },
        getAppleCount() {
            if (this.questionsLeft == 0) {
                return this.appleScore;
            } else {
                return this.appleScore + 1;
            }
        },
        thresholdPosY() {
            return (this.threshold / this.nrQuestions) * 100;
        },
        thresholdReached() {
            if (this.appleScore >= this.threshold) {
                return true;
            } else {
                return false;
            }
        },
        getScorePercent() {
            return (this.score / this.maxScore) * 100;
        },
        getBottomFillSize() {
            var result = (this.thresholdCounter / (this.threshold * 2)) * 100;
            return "height: " + result + "%;";
        },
        getTopFillSize() {
            var result = (this.score / (this.maxScore * 2)) * 100;
            return "height: " + result + "%;";
        },
        yInc() {
            return 88 / this.nrQuestions;
        }
    },
    methods: {
        checkForExplosion(index) {
            if (this.doExplosion && index == this.appleScore) {
                return true;
            } else {
                return false;
            }
        },
        createRotations() {
            for (var i = 0; i < 100; i++) {
                this.appleRotations.push(Math.floor(Math.random() * 46) - 23);
            }
        },
        applePosY(index) {
            if (index == this.appleScore) {
                return 91;
            } else if (this.showAppleAnimation && !this.thresholdReached) {
                this.audioSwoosh.play();
                return -10;
            } else {
                return this.yInc * index + 2;
            }
        },
        appleIndex(index) {
            return 99 - index;
        },
        appleRotate(index) {
            if (index == this.appleScore) {
                return 0;
            } else {
                return this.appleRotations[index];
            }
        }
    },
    mounted() {
        this.createRotations();
        this.audioSwoosh.src = "audio/swoosh.mp3";
    },
    created() {
        eventBus.$on("doApple", correct => {
            if (correct) {
            } else {
                this.doExplosion = true;
                setTimeout(() => {
                    this.doExplosion = false;
                }, 1000);
            }
        });
    }
};
</script>

<style scoped>
.meterContainer {
    position: absolute;
    top: 0;
    left: 0;
    height: 94%;
    width: 100%;
    box-sizing: border-box;
    position: relative;
}
.tube {
    position: absolute;
    top: 10%;
    height: 88%;
    width: 100%;
    position: relative;
}
.highlight {
    position: absolute;
    top: 0;
    z-index: 103;
    height: 100%;
    width: 100%;
    background-image: url(../assets/images/tube-highlight.png);
    background-repeat: repeat-y;
    background-position: center top;
    background-size: 85%;
}
.apple {
    position: absolute;
    z-index: 99;
    left: 5%;
    width: 90%;
    height: auto;
    top: 2px;
}
.appleImage {
    width: 80%;
}
.pointImage {
    position: absolute;
    top: 0;
    left: 0;
}
.appleImageExplosion {
    width: 100%;
}
.applePoint {
    position: absolute;
    z-index: 99;
    left: 15%;
    width: 70%;
    height: 8%;
    bottom: 90%;
    transition: all 0.5s cubic-bezier(0.985, -0.41, 1, 1);
}
.threshold {
    position: absolute;
    z-index: 102;
    left: 7.5%;
    width: 85%;
    height: auto;
    bottom: 60%;
}
.top {
    position: absolute;
    z-index: 101;
    top: 0;
    left: 0;
    background-image: url(../assets/images/tube-top.svg);
    background-repeat: no-repeat;
    background-position: center top;
    height: 10%;
    width: 100%;
    background-size: 85%;
}
.middle {
    position: absolute;
    top: 2.5%;
    height: 95%;
    width: 100%;
    z-index: 1;
    background-image: url(../assets/images/tube-middle.svg);
    background-repeat: repeat-y;
    background-position: center;
    background-size: 85%;
}

.bottom {
    position: absolute;
    bottom: 0;
    height: 10%;
    width: 100%;
    z-index: 100;
    background-image: url(../assets/images/tube-bottom.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 85%;
}

@-webkit-keyframes appleIn {
    0% {
        -webkit-transform: scale(0.5);
        -ms-transform: scale(0.5);
        transform: scale(0.5);
    }
    25% {
        -webkit-transform: scale(0.4);
        -ms-transform: scale(0.4);
        transform: scale(0.4);
    }
    50% {
        -webkit-transform: scale(1.2);
        -ms-transform: scale(1.2);
        transform: scale(1.2);
    }
    75% {
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
    }
    100% {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
